import { defineComponent, ref } from 'vue'
import ButtonGold from "@/components/ButtonGold/ButtonGold.vue";

export default defineComponent({
    name: "PopupCompleted",
    components: { ButtonGold },
    setup() {
        const isClosed = ref<boolean>(false)
        const handleClose = () => {
            console.log('closed')
            isClosed.value = !isClosed.value
        }

        return { isClosed, handleClose }
    }
})